import { Component, Input, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/extensions/services/global.service';

@Component({
  selector: 'emails-card-view',
  templateUrl: './emails-card-view.component.html',
  styleUrl: './emails-card-view.component.scss',
  standalone: false,
})
export class EmailsCardViewComponent {
  @Input() emails: app.models.Email[];
  @Input() props: app.models.DynamicPropsDictionary;

  @Input() deleteEmail: any;
  @Input() viewDetails: any;
}
